export default "__VITE_ASSET__DHDt7w7k__"